import { gql } from "@apollo/client";

export const GET_ULTIMA_EVALUACION = gql`
query getUltimaEvaluacionByPaciente(
    $idPaciente: Int!
) {
    ultimaEvaluacionByPaciente(
        idPaciente: $idPaciente
    )
        {
            numeroAfiliado
            idCliente
            idinstitucion
        }
    }
`;

export const adaptUltimaEvaluacion = (ultimaEv) => {
  return {
    numeroAfiliado: ultimaEv.numeroAfiliado,
    idCliente: ultimaEv.idCliente,
    idInstitucion: ultimaEv.idinstitucion
  };
};